// Display only: selling-unit cost, never multiplied by the quantity threshold.
export function tierCostReference(cost, units, name, price, baseUnit = 'Pcs') {
  const key = String(name || '').trim().toLowerCase();
  const unit = (units || []).find(u => String(u.name || '').trim().toLowerCase() === key && key);
  const pieces = Number(unit ? unit.pieces : 1);
  const base = Number(cost);
  const basis = unit?.name || baseUnit;
  if (!Number.isFinite(base) || base <= 0 || !Number.isFinite(pieces) || pieces <= 0) {
    return {cost:null, difference:null, basis, below:false};
  }
  const modal = base * pieces;
  const sale = price === '' || price == null ? NaN : Number(price);
  const difference = Number.isFinite(sale) ? Math.round((sale - modal) * 100) / 100 : null;
  return {cost:modal, difference, basis, below:difference !== null && difference < 0};
}
